import { render, staticRenderFns } from "./OHeader.vue?vue&type=template&id=7869f1cc&scoped=true&"
import script from "./OHeader.vue?vue&type=script&lang=ts&"
export * from "./OHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OHeader.vue?vue&type=style&index=0&id=7869f1cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7869f1cc",
  null
  
)

export default component.exports